export default "__VITE_ASSET__CRRWiHAm__"